<script lang="ts">
import {defineComponent} from 'vue'
import Dialog from "primevue/dialog"
import {Keyable} from "@/types/keyable.type";

export default defineComponent({
  name: "SumupCheckoutWidget",
  components: {
    Dialog
  },
  props: {
    checkoutId: {
      required: true
    }
  },
  data() {
    return {
      isVisible: false as boolean,
    }
  },
  mounted() {
    this.loadScript()
  },
  methods: {
    loadScript() {
      const script = document.createElement('script')
      script.src = 'https://gateway.sumup.com/gateway/ecom/card/v2/sdk.js'
      script.async = true
      document.head.appendChild(script)
    },
    initWidget() {
      if (window.SumUpCard && this.checkoutId != null) {
        window.SumUpCard.mount({
              id: 'sumup-widget',
              checkoutId: this.checkoutId,
              locale: 'fr-BE',
              onResponse: (type: string, body: Keyable) => {
                if(type == "success"){
                  this.$emit('statusChange', body.status)
                }
              },
            }
        )
      } else {
        console.error("Sumup not loaded");
      }
    },
    close() {
      this.isVisible = false
    },
    open() {
      this.isVisible = true
    },
  },
  emits: ['statusChange', 'closed'],
})
</script>

<template>
    <Dialog v-model:visible="isVisible" modal :header="$t('global_components.sumup_checkout_widget_modal.view.title')" @show="initWidget" @hide="$emit('closed')" class="sumup_checkout_modal" maximizable>
      <div id="sumup-widget"></div>
    </Dialog>
</template>
<style lang="scss">
.sumup_checkout_modal{
  min-height: 500px;
  min-width: 600px;
  margin: 0 1rem;
}
@media (max-width: 600px) {
  .sumup_checkout_modal{
    min-width: 0;
    width: calc(100% - 1rem);
  }
}
</style>
